import { TYPE } from "../actions/types";
const initialState = {
    loggedInDevicesApiRes: {},
    loggeedInDevicesApiLoader: true,
    deleteOwnSessionApiRes: {},
    deleteStaffLoginSessionRes: {}
};

export default function (state = initialState, action, response = action.payload) {
    switch (action.type) {
        case TYPE.FETCH_LOGGEDIN_DEVICE:
            state.loggedInDevicesApiRes = response
            state.loggeedInDevicesApiLoader = false
            return {
                ...state, response: response
            }
        case TYPE.DELETE_OWN_LOGIN_SESSION:
            state.deleteOwnSessionApiRes = response
            return {
                ...state, response: response
            }
        case TYPE.DELETE_STAFF_LOGIN_SESSION:
            state.deleteStaffLoginSessionRes = response
            return {
                ...state, response: response
            }
        case "clear_loggedin_api_res":
            state.loggedInDevicesApiRes = {}
            state.loggeedInDevicesApiLoader= true
            return {
                ...state, response: response
            }
        case "clear_del_own_session_api_res":
            state.deleteOwnSessionApiRes = {}
            return {
                ...state, response: response
            }
        case "clear_staff_login_session_api_res":
            state.deleteStaffLoginSessionRes = {}
            return {
                ...state, response: response
            }
        default:
            return state;
    }

}